import l10n from "./l10n";

export default l10n;
